import { gql } from '@apollo/client';

export const GET_INTERVENTIONS = gql`
  query GetInterventions($input: FilteredInterventions) {
    interventions: getInterventions(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          serviceProviderNames
          beneficiaryCount
          fromDate
          toDate
        }
      }
    }
  }
`;
